export const agentToEmployerPOCMappingTo9142BSectionD = {
  name: "Agent/Attorney Profile Form Mapping",
  machine_name: "agent_attorney_9142B_profile_mapping",
  targetFormDetailName: "Form ETA-9142B",
  targetSectionName: "Attorney or Agent Information <br/>(if applicable)",
  targetSectionLabel: "D",
  fields: [
    {
      profileFieldName: "new_profile_individual_agent_last_name",
      formTargetField: "emppocLastname",
    },
    {
      profileFieldName: "new_profile_individual_agent_first_name",
      formTargetField: "emppocFirstname",
    },
    {
      profileFieldName: "new_profile_individual_agent_middle_name",
      formTargetField: "emppocMiddlename",
    },
    {
      profileFieldName: "new_profile_individual_agent_firm_name",
      formTargetField: "emppocJobtitle",
    },
    {
      profileFieldName: "new_profile_individual_agent_address_1",
      formTargetField: "emppocAddr1",
    },
    {
      profileFieldName: "new_profile_individual_agent_address_2",
      formTargetField: "emppocAddr2",
    },
    {
      profileFieldName: "new_profile_individual_agent_city",
      formTargetField: "emppocCity",
    },
    {
      profileFieldName: "new_profile_individual_agent_state_id",
      formTargetField: "emppocState",
    },
    {
      profileFieldName: "new_profile_individual_agent_zip",
      formTargetField: "emppocPostcode",
    },
    {
      profileFieldName: "new_profile_individual_agent_country_id",
      formTargetField: "emppocCountry",
    },
    {
      profileFieldName: "new_profile_individual_agent_province",
      formTargetField: "emppocProvince",
    },
    {
      profileFieldName: "new_profile_individual_agent_phone",
      formTargetField: "emppocPhone",
    },
    {
      profileFieldName: "new_profile_individual_agent_phone_ext",
      formTargetField: "emppocPhoneext",
    },
    {
      profileFieldName: "new_profile_individual_agent_email",
      formTargetField: "emppocEmail",
    },
  ],
};

export const employerMappingTo9142BSectionD = {
  name: "Employer POC Form Mapping",
  machine_name: "employer_9142B_profile_mapping",
  targetFormDetailName: "Form ETA-9142B",
  targetSectionName: "Employer Point of Contact <br/>Information",
  targetSectionLabel: "D",
  fields: [
    {
      profileFieldName: "poc_emp_last_name",
      formTargetField: "emppocLastname",
    },
    {
      profileFieldName: "poc_emp_first_name",
      formTargetField: "emppocFirstname",
    },
    {
      profileFieldName: "poc_emp_middle_name",
      formTargetField: "emppocMiddlename",
    },
    {
      profileFieldName: "poc_emp_job_title",
      formTargetField: "emppocJobtitle",
    },
    {
      profileFieldName: "poc_emp_address1",
      formTargetField: "emppocAddr1",
    },
    {
      profileFieldName: "poc_emp_address2",
      formTargetField: "emppocAddr2",
    },
    {
      profileFieldName: "poc_emp_city",
      formTargetField: "emppocCity",
    },
    {
      profileFieldName: "poc_emp_country_id",
      formTargetField: "emppocCountry",
    },
    {
      profileFieldName: "poc_emp_state_id",
      formTargetField: "emppocState",
    },
    {
      profileFieldName: "poc_emp_zip",
      formTargetField: "emppocPostcode",
    },
    {
      profileFieldName: "poc_emp_province",
      formTargetField: "emppocProvince",
    },
    {
      profileFieldName: "poc_emp_phone",
      formTargetField: "emppocPhone",
    },
    {
      profileFieldName: "poc_emp_phone_ext",
      formTargetField: "emppocPhoneext",
    },
    {
      profileFieldName: "poc_emp_email",
      formTargetField: "emppocEmail",
    },
  ],
};
